
import React, { Component } from 'react';
import toLower from 'lodash/toLower';
import {
  FormGroup,
  FormControl,
  FormLabel,
} from 'react-bootstrap';
import PhoneInput from 'react-phone-input-2'
import isEmpty from 'lodash/isEmpty';
import isEmail from 'validator/lib/isEmail';
import {isValidMobileNo} from "../../../../../../util/utility";
import countryiso from "../../../../../../constants/countryiso.json"
import leadStyles from '../../../../../../styles/leads.module.css'

class TextElement extends Component {

  constructor(props) {
    super(props);
    this.state = {
      text: '',
    };
  }

  componentDidMount () {
    if(!isEmpty(this.props.element)) {
      this.setState({
        text: this.props.element.defaultValue ? this.props.element.defaultValue : '',
      });
    }
  }

  handleValidationRule = (rule) => {
    if (rule) {
      if (rule === 'email') {
        return this.validateEmail();
      }
      else if (rule === 'phone') {
        return this.validatePhone();
      }
      else {
        return this.validateText();
      }
    } else {
      return null;
    }
  };

  // validate email
  validateEmail = () => {
    if (this.state.text && this.state.text.toString().length > 0) {
      if (isEmail(this.state.text)) {
        return 'success';
      } else {
        return 'error';
      }
    } else {
      return null;
    }
  };

  validatePhone = () => {
    if (this.state.text && this.state.text.toString().length > 4) {
      if (isValidMobileNo(this.state.phone_number.country_code, this.state.phone_number.phone)) {
        return 'success';
      } else {
        return 'error';
      }
    } else {
      return null;
    }
  };

  validateText = () => {
    if (this.state.text && this.state.text.toString().length > 0) {
      if (this.state.text.toString().length > 1) {
        return 'success';
      } else {
        return 'error';
      }
    } else {
      return null;
    }
  };

  handleChange = (e) => {
    this.setState({
      text: e.target.value
    });
    this.props.handleTextOptionSelect(this.props.slideId, this.props.elementId, e.target.value)
  };
  handlePhoneChange = (value, data, event, formattedValue) => {
    const str1 = '+';
    const str2 = data.dialCode;
    const code = str1.concat(str2);
    const phone = value.slice(data.dialCode.length);
    let phone_number = {
      country_code: code,
      phone: phone,
    };
    this.setState({
      text: code.concat(phone),
      phone_number: phone_number,
    });
    this.props.handleTextOptionSelect(this.props.slideId, this.props.elementId, phone_number);
  };

  render() {
    const validation = this.handleValidationRule(this.props.element.validationRule);
    const showValid = validation === 'success';
    const showInvalid = validation === 'error';
    const phoneInputClass = `slideForm-name form-control ${leadStyles['icon-input']}${
      showValid ? ' is-valid' : ''
    }${showInvalid ? ' is-invalid' : ''}`;

    return (
      <div className="row" style={{ margin: '0 auto', padding: '0px 20px 0px 20px' }}>
        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <FormGroup controlId="formBasicText">
            <FormLabel>{this.props.element.textLabel}</FormLabel>
            {this.props.element.validationRule === 'phone' ?
              <>
                <PhoneInput
                  // disableSearchIcon
                  country={this.props.countryCodeDict && this.props.countryCodeDict?.get(this.props.nation.name) ? toLower(this.props.countryCodeDict?.get(this.props.nation.name)) : 'in'}
                  autoFormat
                  // enableSearch
                  onFocus={() => this.props.handleTextOptionFocus(this.props.element.analyticsTriggerName)}
                  onChange={(value, data, event, formattedValue) => this.handlePhoneChange(value, data, event, formattedValue)}
                  value={this.state.text}
                  placeholder={this.props.element.textPlaceholder}
                  // onChange={text => this.setState({text})}
                  inputClass={phoneInputClass}
                  // containerClass="input-group"
                  // buttonClass="text-input-icon"
                  // dropdownStyle={'input-group-addon'}
                />
              </>
              :
              <div
                className={`${leadStyles.textFieldPhoneLike}${
                  showInvalid ? ` ${leadStyles.textFieldPhoneLikeInvalid}` : ''
                }${showValid ? ` ${leadStyles.textFieldPhoneLikeValid}` : ''}`}
              >
                <div className={leadStyles.textFieldPhoneLikeAddon} aria-hidden>
                  <img src="https://cdn.venuemonk.com/user-lead.svg" alt="" />
                </div>
                <FormControl
                  onFocus={() => this.props.handleTextOptionFocus(this.props.element.analyticsTriggerName)}
                  onChange={(e) => this.handleChange(e)}
                  type="text"
                  inputMode="text"
                  autoComplete="name"
                  required={this.props.element.isRequired}
                  name={this.props.element.textElementName}
                  className={`slideForm-name form-control ${leadStyles.textFieldPhoneLikeInput}`}
                  value={this.state.text}
                  placeholder={this.props.element.textPlaceholder}
                />
              </div>
            }
          </FormGroup>
          
        </div>
      </div>
    );
  }
}

export default TextElement;
